import React, { useState } from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Box, FormControl, Typography } from "@mui/material";
import TextField from "@mui/material/TextField";

const DriverDropdown = ({
  options,
  selectedValue,
  onChange,
  warehouseLocationTypeCode,
  sx = {},
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [dropDownOpen, setDropdownOpen] = useState(false);

  const handleOpen = () => setDropdownOpen(true);
  const handleClose = () => {
    setDropdownOpen(false);
    setSearchQuery("");
  };

  const handleSearchClick = (event) => {
    event.stopPropagation();
    setDropdownOpen(true);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setDropdownOpen(true);
  };

  const handleKeyDown = (event) => {
    const keysToPrevent = [
      ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i)),
      ...Array.from({ length: 9 }, (_, i) => String(i + 1)),
    ];
    if (keysToPrevent.includes(event.key?.toLowerCase())) {
      event.stopPropagation();
    }
  };

  const filteredOptions = options.filter((item) =>
    item.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  if (warehouseLocationTypeCode !== "VL") {
    return null;
  }

  return (
    <FormControl
      fullWidth
      size="small"
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "55px",
          borderRadius: "8px",
          marginTop: "5px",

          ...sx,
        },
      }}
      variant="outlined"
    >
      <Select
        id="Dropdown"
        value={selectedValue}
        onChange={onChange}
        displayEmpty
        open={dropDownOpen}
        onOpen={handleOpen}
        onClose={handleClose}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              overflowY: "auto",
            },
          },
        }}
        sx={{
          "& .MuiSelect-select": {
            bgcolor: "transparent",
          },
          "& .MuiOutlinedInput-root": {
            "& fieldset": {
              borderColor: "transparent",
            },
          },
        }}
        renderValue={(selected) => {
          if (!selected) {
            return (
              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "220px",
                }}
              >
                Select a driver
              </Typography>
            );
          }

          const selectedItem = options.find((item) => item.name === selected);
          return (
            <Typography
              variant="body2"
              fontWeight="bold"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                // maxWidth: "220px",
              }}
            >
              {selectedItem?.name || ""}
            </Typography>
          );
        }}
      >
        {/* Static Search Bar */}
        <Box
          sx={{
            padding: "8px",
            position: "sticky",
            top: 0,
            backgroundColor: "white",
            zIndex: 1,
          }}
        >
          <TextField
            fullWidth
            size="small"
            placeholder="Search..."
            value={searchQuery}
            onChange={handleSearchChange}
            onClick={handleSearchClick}
            onKeyDown={handleKeyDown}
            sx={{
              margin: "8px 0",
            }}
          />
        </Box>

        {/* Dynamically Filtered List */}
        {filteredOptions.length > 0 ? (
          filteredOptions.map((item, index) => (
            <MenuItem key={index} value={item.name}>
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "250px",
                }}
              >
                {item.name}
              </Typography>
            </MenuItem>
          ))
        ) : (
          <MenuItem disabled>
            <Typography variant="body2" sx={{ color: "#9e9e9e" }}>
              No results found
            </Typography>
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default DriverDropdown;
